export enum PreWorkupLabJugStatus {    
    NotSent = 0,
    SentOne = 1,
    SentTwo = 2,
    NoneReceived = 10,
    Received = 15
}